"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;

var tslib_1 = require("tslib");

var ui_box_1 = require("@hopin-team/ui-box");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_button_1 = require("@hopin-team/ui-button");

var ui_grid_1 = require("@hopin-team/ui-grid");

var ui_menu_1 = require("@hopin-team/ui-menu");

var ui_text_1 = require("@hopin-team/ui-text");

var date_fns_1 = require("date-fns");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var lib_1 = require("../lib");

var day_1 = require("../partials/day");

var calendar_grid_1 = require("../styled/calendar-grid");

var table_1 = require("./table");

var time_picker_1 = require("./time-picker");

var DatePicker = function DatePicker(_a) {
  var withTime = _a.withTime;

  var _b = (0, react_1.useContext)(context_1.DateFieldContext),
      date = _b.date,
      onDateChange = _b.onDateChange,
      onMonthPick = _b.onMonthPick,
      onYearPick = _b.onYearPick,
      dateOptions = _b.dateOptions;

  (0, react_1.useEffect)(function () {
    if (!date) {
      onDateChange(new Date());
    }
  }, [date, onDateChange]);
  var onClose = (0, react_1.useContext)(ui_menu_1.MenuContext).onClose;
  var week = (0, react_1.useMemo)(function () {
    return (0, lib_1.generateWeek)(dateOptions);
  }, [dateOptions]);
  var monthDates = (0, react_1.useMemo)(function () {
    return date && (0, lib_1.generateMonth)({
      date: date,
      dateOptions: dateOptions
    });
  }, [dateOptions, date]);

  var onNextMonth = function onNextMonth() {
    return date && onDateChange((0, date_fns_1.addMonths)(date, 1));
  };

  var onPrevMonth = function onPrevMonth() {
    return date && onDateChange((0, date_fns_1.subMonths)(date, 1));
  };

  var onSelectDate = function onSelectDate() {
    return onClose === null || onClose === void 0 ? void 0 : onClose();
  };

  if (!date) {
    return null;
  }

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ui_grid_1.Grid, {
    gridTemplateColumns: "2rem 1fr 1fr 2rem",
    gridGap: "0.5rem",
    px: 3,
    pt: 3,
    pb: 1,
    "data-testid": "date-picker"
  }, react_1.default.createElement(ui_butticon_1.Butticon, {
    icon: "arrow-back",
    size: "tiny",
    onClick: onPrevMonth,
    title: "Previous month",
    isGhost: true,
    type: "button",
    my: 0.5
  }), react_1.default.createElement(ui_button_1.Button, {
    size: "small",
    pattern: "secondary",
    isOutlined: true,
    onClick: onMonthPick,
    type: "button"
  }, react_1.default.createElement(ui_text_1.Text, {
    pattern: "caption"
  }, (0, date_fns_1.format)(date, 'MMMM'))), react_1.default.createElement(ui_button_1.Button, {
    size: "small",
    pattern: "secondary",
    isOutlined: true,
    onClick: onYearPick,
    type: "button"
  }, react_1.default.createElement(ui_text_1.Text, {
    pattern: "caption"
  }, (0, date_fns_1.format)(date, 'yyyy'))), react_1.default.createElement(ui_butticon_1.Butticon, {
    icon: "arrow-forward",
    size: "tiny",
    onClick: onNextMonth,
    title: "Next month",
    isGhost: true,
    type: "button",
    my: 0.5,
    ml: 1
  })), react_1.default.createElement(ui_box_1.Box, {
    px: 3,
    pb: !withTime ? 3 : 0
  }, react_1.default.createElement(table_1.Table, {
    type: "day",
    label: "Month",
    date: date,
    onDateChange: onDateChange,
    onSelect: onSelectDate
  }, react_1.default.createElement("thead", null, react_1.default.createElement("tr", {
    role: "row"
  }, week.map(function (_a) {
    var label = _a.label,
        display = _a.display;
    return react_1.default.createElement("th", {
      role: "columnheader",
      "aria-label": label,
      key: label
    }, react_1.default.createElement("abbr", {
      title: label
    }, display));
  }))), react_1.default.createElement(calendar_grid_1.CalendarGrid, null, monthDates === null || monthDates === void 0 ? void 0 : monthDates.map(function (week, i) {
    return react_1.default.createElement("tr", {
      key: "week-".concat(i)
    }, week.map(function (day, i) {
      return react_1.default.createElement(day_1.Day, {
        key: "day-cell-".concat(i),
        day: day,
        selectedDate: date,
        onSelect: onDateChange
      });
    }));
  })))), withTime && react_1.default.createElement(time_picker_1.TimePicker, null));
};

exports.DatePicker = DatePicker;